export { default, RESET_PASSWORD_PATH } from "./ResetPasswordPage";
